<template>
  <div class="DeliveryLimit">
    <Clock/>
    <div>
      {{ deliveryLimitTimeLabel }}の注文で<span class="accent">{{ deliveryLimitDateLabel }}</span>
    </div>
  </div>
</template>

<script lang="ts">
import { defineNuxtComponent } from '#app'
import { Clock } from '@ka-nabellinc/ka-nabell-icons'

export default defineNuxtComponent({
  components: {
    Clock
  },
  props: {
    deliveryLimitTimeLabel: {
      type: String,
    },
    deliveryLimitDateLabel: {
      type: String
    }
  }
})
</script>

<style scoped>
.DeliveryLimit {
  height: 20px;
  display: flex;
  align-items: center;
  gap: 4px;
  font-size: 12px;
  line-height: 150%;
  letter-spacing: 0.12px;
}

.accent {
  font-weight: 700;
  letter-spacing: 0.15px;
}
</style>
